const _ = require('lodash');
const EnvReportInterface = require('../reportData/envReportInterface');

const userBaseFields = ['id', 'email', 'firstname', 'lastname', 'isDeleted'];

const SUPER_ADMIN_EMAIL = 'admin@mugs.info';

const superAdminReplaceFields = {
	email: 'support@relevant-digital.com',
	firstname: 'Relevant',
	lastname: 'Support',
	picture: Object.assign('/src/assets/Relevant_logoicon.png', { noModify: true }),
};

const getterFns = {
	initials: (u) => [u.firstname, u.lastname].filter((i) => !!i).map((i) => i[0]).join(''),
	fullname: (u) => [u.firstname, u.lastname].filter((i) => !!i).join(' '),
};

const userGetters = _.mapValues(getterFns, (fn) => ({
	get() { return fn(this); },
	enumerable: false,
}));

/** Return a summary object only containing fields in 'userBaseFields' + getters */
const userSummary = (u) => (!u ? null : Object.defineProperties(_.pick(u, userBaseFields), userGetters));

/** Is 'user' a super admin? */
const isSuperUserObject = (user) => user?.email === SUPER_ADMIN_EMAIL;

/** Hide strange/worrying admin@mugs.info email etc for super admin user, for non super admins */
const uiAdjustedUserObject = (user, inSuperAdminMode) => {
	if (!isSuperUserObject(user) || inSuperAdminMode) {
		return user;
	}
	const res = { ...user, ...superAdminReplaceFields };
	return Object.assign(res, _.mapValues(getterFns, (fn) => fn(res)));
};

const superAdminVerificationHosts = () => {
	const { isMasterInstance, inProduction } = EnvReportInterface.getGenericData?.() || {};
	if (isMasterInstance && inProduction === false) {
		return {
			gui: 'https://dev.relevant-digital.com',
			api: 'https://dev-api.relevant-digital.com',
		};
	}
	return {
		gui: 'https://apps.relevant-digital.com',
		api: 'https://api.relevant-digital.com',
	};
};

module.exports = {
	userSummary,
	isSuperUserObject,
	SUPER_ADMIN_EMAIL,
	uiAdjustedUserObject,
	superAdminVerificationHosts,
};
